import { Phone, MessageCircle, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PHONE_TEL, WA_URL } from "@/lib/constants";
import { Logo } from "@/components/Logo";

export const Footer = () => {
    const { t } = useLang();

    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-obsidian pb-24 md:pb-0">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8">
                    <div>
                        <Logo />
                        <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
                            {t("hero.sub")}
                        </p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3">
                        <a
                            href={PHONE_TEL}
                            data-testid="footer-call-btn"
                            className="inline-flex items-center justify-center gap-2.5 rounded-xl border border-white/10 bg-white/5 px-5 py-3 text-sm font-bold text-white transition-all hover:border-volt/50 hover:text-volt"
                        >
                            <Phone className="h-4 w-4 text-volt" />
                            (346) 318-5888
                        </a>
                        <a
                            href={WA_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-wa-btn"
                            className="inline-flex items-center justify-center gap-2.5 rounded-xl border border-whatsapp/40 bg-whatsapp/10 px-5 py-3 text-sm font-bold text-whatsapp transition-all hover:bg-whatsapp/20"
                        >
                            <MessageCircle className="h-4 w-4" />
                            WhatsApp
                        </a>
                    </div>
                </div>

                <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/5 pt-6 text-xs font-semibold text-slate-600">
                    <span data-testid="footer-rights">{t("footer.rights")}</span>
                    <a
                        href="/admin"
                        data-testid="owner-login-link"
                        className="transition-colors hover:text-volt"
                    >
                        Owner login
                    </a>
                    <span className="inline-flex items-center gap-1.5">
                        <MapPin className="h-3.5 w-3.5 text-volt/70" />
                        {t("footer.line")}
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
